import React, { useState, useEffect} from "react";
import "./index.css";
import axios from "axios";
import WeatherForecastDay from "./WeatherForecastDay";

export default function WeatherForecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [forecast, setForecast] = useState(null);

  useEffect(() => {
setLoaded(false);
  },[props.coordinates]);

   function handleResponse (response) {
  setForecast(response.data.daily);
  setLoaded(true);
}

function load() {
  let apiKey = "cct8eebao110f93a5ba96c40f6fbbab8";
  let longitude = props.coordinates.longitude;
  let latitude = props.coordinates.latitude;
  let apiUrl = `https://api.shecodes.io/weather/v1/forecast?lat=${latitude}&lon=${longitude}
&key=${apiKey}&units=metric`;

  axios.get(apiUrl).then(handleResponse);
}

if (loaded) {
  console.log(forecast);
  return (
    <div className="WeatherForecast">
      <div className="row">
        {forecast.map(function(dailyForecast, index) {
          if (index < 4) {
            return (
              <div className="col" key={index}>
                <WeatherForecastDay data={dailyForecast} />
              </div>
            );
          } else {
            return null;
          }
        })}
        
      </div>
    </div>
  );
 } else {
load();

return null;
 }   
}
